<template>
    <div class="d-block">
        <div class="index-carousel" :style="{width: windowClient.width + 'px', height: windowClient.height - 176 + 'px'}">
            <div class="d-block bg-dark overflow-hidden" :style="{width: windowClient.width + 'px', height: windowClient.height - 176 + 'px'}" v-if="bannerData.mediaType === 'VIDEO'">
                <video autoplay loop muted="true" :src="bannerData.urls[0]" :style="{width: windowClient.width + 'px', height: windowClient.height - 176 + 'px', objectFit: 'fill'}"/>
            </div>
            <Carousel autoplay :loop="true" dots="none" :autoplay-speed="4500" v-model="bannerActive" v-if="bannerData.mediaType === 'IMAGE'">
                <CarouselItem v-for="(item, index) in bannerData.urls" :key="index">
                    <div class="d-block bg-black overflow-hidden" :style="{width: $common.winContent().width + 'px', height: $common.winContent().height - 72 + 'px'}">
                        <div class="d-flex justify-center height-all">
                            <img :src="item"/>
                        </div>
                    </div>
                </CarouselItem>
            </Carousel>
            <div class="information">
                <h1 style="font-size: 5em;" v-if="bannerData.titleType === 'TXT'">{{ bannerData.title }}</h1>
                <h6 v-if="bannerData.titleType === 'ICON'">
                    <img :src="bannerData.icon" style="max-height: 128px;"/>
                </h6>
                <br/>
                <h1>{{ bannerData.introduction }}</h1>
                <br/>
                <br/>
                <router-link to="/about">{{ lang === 'zh-cn' ? '关于源音' : 'About Anystage' }}</router-link>
            </div>
        </div>
        <div class="index-news-box">
            <swiper :options="swiperOption">
                <swiper-slide v-for="(item, index) in newsActivityList" :key="index">
                    <div class="d-flex justify-start mb-sm">
                        <router-link class="line-h-0" to="">
                            <img :src="item.cover" style="width: 164px; height: 128px; margin-right: 16px;"/>
                        </router-link>
                        <div class="d-flex-item overflow-hidden">
                            <router-link to="">
                                <h3 class="line-h-30 c-black overflow-text">{{ item.title }}</h3>
                            </router-link>
                            <p class="line-h-24 mtb-ns overflow-hidden" style="height: 48px;">{{ item.introduction }}</p>
                            <span class="space">&nbsp;</span>
                            <router-link class="d-flex justify-start c-success" :to="{name: 'newsDetails', params: {data: JSON.stringify(item)}}">
                                <Icon type="ios-arrow-dropright" size="20"/>
                                <span class="plr-ns">{{ lang === 'zh-cn' ? '详情' : 'View more' }}</span>
                            </router-link>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="index-logo-box">
            <span class="d-block size-18">{{ lang === 'zh-cn' ? '品牌' : 'Brand' }}</span>
            <div class="d-flex-item mlr-md plr-xs bdl-1 bdr-1 b-light">
                <div class="d-flex justify-start">
                    <div class="d-inline" v-for="(item, index) in logoListData" :key="index">
                        <a data-hover="brand" class="d-flex justify-center bd-1" target="_blank" :href="item.url" v-if="item.url !== ''" style="width: 120px; height: 24px; padding: 3px; margin: 0 8px;">
                            <img :src="item.image" style="max-width: 100%; max-height: 100%;"/>
                        </a>
                        <span class="d-flex justify-center bd-1" v-else style="width: 120px; height: 24px; padding: 3px; margin: 0 8px;">
                            <img :src="item.image" style="max-width: 100%; max-height: 100%;"/>
                        </span>
                    </div>
                </div>
            </div>
            <Button type="success" @click="__onComments"><Icon type="md-chatboxes" size="16"/>&nbsp;{{ lang === 'zh-cn' ? '在线咨询' : 'Online consultation' }}</Button>
        </div>
    </div>
</template>

<style scoped>
    [data-hover="brand"]:hover{
        border-color: #13aa52;
    }
</style>

<script type="text/javascript">
    export default {
        components: {},
        props: {
            lang: {
                type: String,
            }
        },
        data() {
            return {
                language: '',
                bannerData: {},
                bannerActive: 0,
                newsActivityList: [],
                swiperOption: {
                    notNextTick: true,
                    loop: false, // 循环
                    initialSlide: 0, // 初始化索引
                    autoplay: true, // 自动
                    speed: 500, // 滑动速度
                    direction: "vertical", // 方向
                },
                logoListData: [],
                windowClient: {},
            }
        },
        watch: {
            lang: {
                handler(val){
                    this.newsActivityList = [];
                    console.log('当前语言:----->' + val);
                    this.language = val;
                    this.__getBanner();
                    this.__getNews();
                    this.__getActivity();
                    this.__getLogos();
                },
                deep: true, // 深度监听
            },
            windowClient(value){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if(!this.timer){
                    // 一旦监听到的windowClient值改变，就将其重新赋给data里的windowClient
                    this.windowClient = value;
                    this.timer = true;
                    let that = this;
                    setTimeout(function(){
                        console.log('windowClient---------->', that.windowClient);
                        that.timer = false;
                    },400);
                }
            },
        },
        created() {
            console.log('当前语言----->' + this.$store.state.language);
            this.language = this.$store.state.language;
            this.windowClient = {
                width: window.innerWidth,
                height: window.innerHeight,
            }
        },
        mounted () {
            this.__getWindowResize();
            this.__getBanner();
            this.__getNews();
            this.__getActivity();
            this.__getLogos();
        },
        methods:{
            __getWindowResize(){
                window.onresize = () => {
                    return (() => {
                        this.windowClient = {
                            width: window.innerWidth,
                            height: window.innerHeight,
                        };
                    })()
                };
            },
            __getBanner(){
                this.$api.getHttp('banner?bannerType=INDEX', {
                    language: this.language,
                }).then((res) => {
                    console.log('<---------- res ---------->');
                    console.log(res);
                    if (res.status === 200){
                        this.bannerData = res.data.data;
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getNews(){
                this.$api.getHttp('news', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        var _data = res.data.data.data;
                        _data.forEach(item=>{
                            if (item.enable === true && item.recommend === true){
                                item.type = 'NEWS';
                                this.newsActivityList.push(item);
                            }
                        });
                        console.log(this.newsActivityList);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getActivity(){
                this.$api.getHttp('activities', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        var _data = res.data.data.data;
                        _data.forEach(item=>{
                            if (item.enable === true && item.recommend === true){
                                item.type = 'ACTIVITY';
                                this.newsActivityList.push(item);
                            }
                        });
                        // console.log(this.newsActivityList);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getLogos(){
                this.$api.getHttp('index-logo', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.logoListData = res.data.data;
                        console.log(this.logoListData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __onComments(){
                this.$bus.emit('isComments', true);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/index.vue